/* CCM19 -> Shopify Customer Privacy API
 *
 * Warum im Theme und nicht in CCM19:
 * Die Einbindung "Shopify" traegt zwar ein passendes Skript, wird aber nie
 * ausgefuehrt, weil in CCM19 die Option "Technisch notwendige Einbindungen
 * ohne Zustimmung laden" aktiv ist. Hier laeuft die Bruecke bei jedem
 * Seitenaufruf und synchronisiert in BEIDE Richtungen, also auch beim Widerruf.
 *
 * Zuordnung: die CCM19-Einbindung "Shopify Pixel" hat den Zweck
 * "Analyse / Statistiken". Deshalb wird daraus nur das Signal analytics
 * abgeleitet. marketing bleibt aus, solange es dafuer keine eigene
 * Einbindung mit dem Zweck "Anzeigen / Ads" gibt - sonst wuerde mehr
 * eingewilligt als im Banner abgefragt wurde.
 */
(function () {
  var EMBEDDING = 'Shopify Pixel';

  var SIGNALS = {
    analytics: true,
    marketing: false,
    preferences: false,
    sale_of_data: false
  };

  var featuresRequested = false;
  var lastApplied = null;
  var ticks = 0;

  function isAccepted() {
    try {
      var list = window.CCM && window.CCM.acceptedEmbeddings;
      if (!list || typeof list.length !== 'number') return null;
      for (var i = 0; i < list.length; i++) {
        if (list[i] && list[i].name === EMBEDDING) return true;
      }
      return false;
    } catch (e) {
      return null;
    }
  }

  function sync() {
    try {
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

      if (!featuresRequested) {
        featuresRequested = true;
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function () {}
        );
      }

      var privacy = window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') return;

      var accepted = isAccepted();
      if (accepted === null) return;
      if (accepted === lastApplied) return;

      lastApplied = accepted;

      privacy.setTrackingConsent(
        {
          analytics: accepted && SIGNALS.analytics,
          marketing: accepted && SIGNALS.marketing,
          preferences: accepted && SIGNALS.preferences,
          sale_of_data: accepted && SIGNALS.sale_of_data
        },
        function () {}
      );
    } catch (e) {
      /* niemals den Seitenaufbau stoeren */
    }
  }

  var timer = window.setInterval(function () {
    ticks++;
    sync();
    if (ticks > 600) window.clearInterval(timer);
  }, 500);

  window.addEventListener('ccm19WidgetClosed', sync);
  window.addEventListener('ccm19WidgetLoaded', sync);
  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
